export default __webpack_public_path__ + "static/media/foto_gelar.b47e37e1.jpg";